import '../../modules/system/assets/js/framework';
import '../../node_modules/bootstrap/dist/js/bootstrap.min';
import '../../node_modules/owl.carousel/dist/owl.carousel.min';
import '../../node_modules/jquery.maskedinput/src/jquery.maskedinput';

import './js/validation';
import './partials/forms/input';

import './partials/forms/modal/form';
import './partials/forms/index/index';
import './partials/forms/comments/comment';
import './partials/forms/right-column/form';
import './partials/forms/right-column/form-pdf';
import './partials/snippets/pdfownload-pdf-form';
import './partials/snippets/consult-form';
import './partials/forms/pre-footer/pre-footer';
import './partials/forms/download-files/download-files';
import './partials/content/cookies/cookies';
import './partials/content/client-slider/client-slider';
import './partials/catalog/cart/cart';
import './partials/footer/footer-columns/footer-columns';
import './partials/common/gallery-slider/gallery-slider';
import './partials/common/current-table/current-table';
import './partials/common/index-article-slider/index-article-slider';

import './partials/common/scroll-top/scroll-top';
import './partials/common/wysiwyg/wysiwyg';
import './partials/common/collapse/collapse';
import './partials/snippets/video-form';

import blogPostContentSlider from './partials/blog-post/slider-content/slider-content';


export default new class commonComponent {
  constructor() {
    this.headerContainer = '._header-container';
    this.loadingHeaderClass = '_loading';
    this.buttonMenu = '._button-menu';
    this.navPanel = '._nav-panel';
    this.menuWrapper = '_nav-panel';
    this.searchWrapper = '_search-result';
    this.menuPartialSelector = 'menu/mobile';
    this.contactPatrial = 'menu/contact';
    this.contactWrapper = '_contact-top';

    this.tab();

    document.addEventListener('DOMContentLoaded', () => {
      this.loadMenu();
      this.loadContact();

      this.init();
      this.performedSliders();

      this.openMobileMenu();
      this.engineMobileMenu();

      this.toggleCategorySlider();
    });
  }

  init() {
    this.phoneMask();

    if ($(document).width() <= 768) {
      this.mobileSlider();
    }

    document.addEventListener('teletype.opened', () => {
      // eslint-disable-next-line no-undef
      ym(71321556, 'reachGoal', 'teletype.opened');
    });
  }

  // eslint-disable-next-line class-methods-use-this
  performedSliders() {
    $('._performed-carousel-1').owlCarousel({
      smartSpeed: 500,
      margin: 15,
      items: 1,
      loop: false,
      nav: true,
      dots: true,
      responsiveBaseElement: 'body',
      navText: [
        // eslint-disable-next-line sonarjs/no-duplicate-string
        '<div class="prev-performed-slider"></div>',
        // eslint-disable-next-line sonarjs/no-duplicate-string
        '<div class="next-performed-slider"></div>',
      ],
    });
    $('._performed-carousel-3').owlCarousel({
      autoplayTimeout: 7000,
      smartSpeed: 500,
      margin: 15,
      loop: true,
      nav: true,
      dots: true,
      responsiveBaseElement: 'body',
      navText: [
        '<div class="prev-performed-slider"></div>',
        '<div class="next-performed-slider"></div>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        480: {
          items: 1,
        },
        768: {
          items: 1,
        },
        1200: {
          items: 3,
        },
      },
    });
    $('._slider').owlCarousel({
      autoplayTimeout: 7000,
      smartSpeed: 500,
      margin: 15,
      loop: false,
      nav: false,
      dots: false,
      responsiveBaseElement: 'body',
      navText: [
        '<div class="prev-performed-slider"></div>',
        '<div class="next-performed-slider"></div>',
      ],
      responsive: {
        0: {
          items: 2,
        },
        480: {
          items: 4,
        },
        768: {
          items: 5,
        },
        1200: {
          items: 6,
        },
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  mobileSlider() {
    $('._mobile-slider')
      .addClass('owl-carousel');
    $('._mobile-slider').owlCarousel({
      smartSpeed: 1500,
      margin: 0,
      items: 1,
      loop: true,
      dots: true,
    });
    $('._mobile-slider-two')
      .addClass('owl-carousel');
    $('._mobile-slider-two').owlCarousel({
      smartSpeed: 400,
      margin: 0,
      items: 2,
      loop: false,
      dots: true,
    });
  }

  loadMenu() {
    if ($(document).width() >= 1200) {
      this.menuPatrial = 'menu/desktop';
      $.request('onAjax', {
        update: {
          [this.menuPatrial]: `.${this.menuWrapper}`,
        },
        success(res) {
          this.success(res);
        },
      });
    }
  }

  loadContact() {
    $.request('onAjax', {
      update: {
        [this.contactPatrial]: `.${this.contactWrapper}`,
      },
      success(res) {
        $('._header-container').removeClass('_loading');
        this.success(res);
      },
    });
  }

  openMobileMenu() {
    $(document)
      .on('click', '._button-menu', () => {
        $.request('onAjax', {
          update: {
            [this.menuPartialSelector]: `.${this.menuWrapper}`,
          },
          success(res) {
            this.success(res);
            // eslint-disable-next-line sonarjs/no-duplicate-string
            $('.mobile_menu_container')
              .addClass('loaded');
            // eslint-disable-next-line sonarjs/no-duplicate-string
            $('.mobile_menu_overlay')
              .fadeIn();
          },
        });
      });
  }

  // eslint-disable-next-line class-methods-use-this
  engineMobileMenu() {
    $(document)
      // eslint-disable-next-line func-names
      .on('click', '.mobile_menu_container .parent', function (e) {
        e.preventDefault();
        $('.mobile_menu_container.activity')
          .removeClass('activity');
        $(this)
          .siblings('ul')
          .addClass('loaded')
          .addClass('activity');
      });
    $(document)
      // eslint-disable-next-line func-names
      .on('click', '.mobile_menu_container .back', function (e) {
        e.preventDefault();
        $('.mobile_menu_container .activity')
          .removeClass('activity');
        $(this)
          .parent()
          .parent()
          .removeClass('loaded');
        $(this)
          .parent()
          .parent()
          .parent()
          .parent()
          .addClass('activity');
      });
    $(document)
      // eslint-disable-next-line func-names
      .on('click', '.mobile_menu_overlay', function () {
        $('.mobile_menu_container')
          .removeClass('loaded');
        $(this)
          .fadeOut(() => {
            $('.mobile_menu_container .loaded')
              .removeClass('loaded');
            $('.mobile_menu_container .activity')
              .removeClass('activity');
          });
      });
    $(document)
      .on('click', '.mobile_menu_close', () => {
        $('.mobile_menu_container')
          .removeClass('loaded');
        $('.mobile_menu_overlay')
          .fadeOut();
      });
  }

  // eslint-disable-next-line class-methods-use-this
  phoneMask() {
    $('.mobile-phone')
      .mask('+7 (999) 999-99-99');
  }

  // eslint-disable-next-line class-methods-use-this
  toggleCategorySlider() {
    const btn = document.querySelector('.list-toggle > span');
    $(document)
      .on('click', '._open-list', () => {
        $('.u-list')
          .toggleClass('open');
        btn.innerHTML = (btn.innerHTML === 'Показать всё') ? btn.innerHTML = 'Скрыть' : btn.innerHTML = 'Показать всё';
      });
  }

  // eslint-disable-next-line class-methods-use-this
  tab() {
    $(document).ready(() => {
      // eslint-disable-next-line no-restricted-globals
      let url = location.href.replace(/\/$/, '');

      // eslint-disable-next-line no-restricted-globals
      if (location.hash) {
        const hash = url.split('#');
        const checkItems = hash[1].match(/items/);
        if (checkItems) {
          $(`#description-tab a[href="#${hash[1]}"]`).tab('show');
          blogPostContentSlider.init();
          // eslint-disable-next-line no-restricted-globals
          url = location.href.replace(/\/#/, '#');
          // eslint-disable-next-line no-restricted-globals
          history.replaceState(null, null, url);
          setTimeout(() => {
            $(window).scrollTop(0);
          }, 400);
        }
      }

      $('a[data-toggle="tab"]').on('click', function () {
        let newUrl;
        const hash = $(this).attr('href');
        if (hash === '#home') {
          // eslint-disable-next-line prefer-destructuring
          newUrl = url.split('#')[0];
          blogPostContentSlider.init();
        } else {
          newUrl = url.split('#')[0] + hash;
          blogPostContentSlider.init();
        }
        newUrl += '/';
        // eslint-disable-next-line no-restricted-globals
        history.replaceState(null, null, newUrl);
      });
    });
  }
}();
